export const normalizeForMatch = (text: string): string =>
  text
    .toLowerCase()
    .split(/[^\p{L}\p{N}]+/u)
    .filter(Boolean)
    .join(' ');

export const isExactNameMatch = (
  name: string,
  query: string,
  extension?: string,
): boolean => {
  const normalizedQuery = normalizeForMatch(query);
  if (!normalizedQuery) return false;

  const candidates = [name];
  if (extension) {
    const suffix = `.${extension}`;
    if (name.toLowerCase().endsWith(suffix.toLowerCase())) {
      candidates.push(name.slice(0, -suffix.length));
    } else {
      candidates.push(`${name}${suffix}`);
    }
  }

  return candidates.some(
    (candidate) => normalizeForMatch(candidate) === normalizedQuery,
  );
};

const OPENING_QUOTES = ['"', '“', '„'];

export const shouldSuggestQuotes = (query: string): boolean => {
  const trimmed = query.trim();
  if (OPENING_QUOTES.some((quote) => trimmed.startsWith(quote))) {
    return false;
  }
  return normalizeForMatch(trimmed).split(' ').length >= 2;
};
